import Vue from 'vue';
import {
  createVideoRoom, getVideoReserve, cancelReserve
} from '../../../services/personnelService/videoCallService';
import {getTags} from "@/services/backendService/tagsService";

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  datum: [],
  pagination: {
    current_page: 0,
    per_page: 5
  },
  setVideoReserve: [],
};

// getters
const getters = {};

// actions
const actions = {
  // 建立視訊聊天
  async createVideoRoomHandler({commit}, params) {
    return createVideoRoom(params);
  },
  // 建立視訊聊天
  async getVideoReserveHandler({commit}, params) {
    const data = await getVideoReserve(params);
    commit('setVideoReserve', data);
  },
  // 取消預約
  async cancelReserveHandler({commit}, params) {
    return cancelReserve(params);
  },
};

// mutations
const mutations = {
  setVideoReserve(state, data) {
    Vue.set(state, 'setVideoReserve', data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
